module.exports = __webpack_public_path__ + "img/maas_wrapbg5.354b4fdb.png";